export const setLocalStorageAccessAuth = (authResult: any) => {
  const exp = authResult?.idTokenPayload?.exp;
  const cookieValue = window.btoa(
    JSON.stringify({
      accessToken: authResult.accessToken,
      expiresAt: exp,
    }),
  );

  localStorage.setItem('auth', cookieValue);
};

export const deleteLocalStorageAuth = () => {
  localStorage.removeItem('auth');
};

export const getLocalStorageAccessToken = () => {
  const data = localStorage.getItem('auth');

  if (!data) {
    return undefined;
  }

  const { accessToken } = JSON.parse(window.atob(data));

  return accessToken;
};


export const setLocalStorageImpersonated = (impersonatedId: string) => {
  const cookieValue = window.btoa(
    JSON.stringify({
      id: impersonatedId,
      expiresAt: Date.now() + 24 * 60 * 60 * 1000, // valid for a day
    }),
  );

  localStorage.setItem('imp', cookieValue);
};

export const getLocalStorageImpersonatedId = () => {
  const data = localStorage.getItem('imp');

  if (!data) {
    return undefined;
  }

  const { id } = JSON.parse(window.atob(data));

  return id;
};

export const deleteLocalStorageImpersonated = () => {
  localStorage.removeItem('imp');
};
